import hash from 'stable-hash'

const swrCompare = (a: unknown, b: unknown) => hash(a) === hash(b)

export const swrOptions = {
  compare: swrCompare,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  refreshInterval: 0,
  errorRetryCount: 3
}
